

const BlockContainer = props => {

    return (
        <div 
            className='container-fluid'
            style={{ 
                padding : '20px', 
                background: 'white', 
                boxShadow: '0 3px 6px 0 #f0f0f0',
            }}
        >
            {props.children}
        </div>
    )
}

export default BlockContainer;